import {AfterViewInit, Component, EventEmitter, Input, Output} from "@angular/core";
import {FUISpinnersService} from "@fedelta-pos/ui";
import {CustomerPortalService} from "../customer-portal.service";
import {CustomerPortalModel, CustomerPortalPages} from "../customer-portal.model";

@Component({
    selector: "fhm-customer-portal-page-content-content",
    styleUrls: ["./customer-portal-page-content.component.scss"],
    templateUrl: "./customer-portal-page-content.component.html",
    providers: [CustomerPortalService, CustomerPortalModel],
    standalone: false
})
export class CustomerPortalPageContentComponent implements AfterViewInit {

    CustomerPortalPages = CustomerPortalPages;

    @Input() showClose: boolean;

    @Output() closed: EventEmitter<any> = new EventEmitter();

    constructor(private spinnersService: FUISpinnersService,
                public model: CustomerPortalModel) {
    }

    ngAfterViewInit(): void {
        this.init();
    }

    async init(): Promise<void> {
        this.spinnersService.open();
        try {
            await this.model.load();
        } finally {
            this.spinnersService.close();
        }
    }

    async confirmBilling(paymentMethodId: string): Promise<void> {
        this.spinnersService.open();
        try {
            await this.model.confirmBilling(paymentMethodId);
        } finally {
            this.spinnersService.close();
        }
    }
}
